import { DateTime } from 'luxon'

export default function getRelativeTimeShort({
  time,
  timeIsInFuture = false,
}: {
  time: DateTime
  timeIsInFuture?: boolean
}): string {
  const now = DateTime.now()
  const duration = timeIsInFuture ? time.diff(now) : now.diff(time)

  if (duration.as('seconds') < 10) {
    return 'Now'
  }

  if (duration.as('seconds') < 60) {
    return `${duration.toFormat('s')}s`
  }

  if (duration.as('minutes') < 60) {
    return `${duration.toFormat('m')}m`
  }

  if (duration.as('hours') < 24) {
    return `${duration.toFormat('h')}h`
  }

  if (duration.as('days') < 30) {
    return `${duration.toFormat('d')}d`
  }

  if (duration.as('days') < 365) {
    return `${duration.toFormat('M')}mo`
  }

  return `${duration.toFormat('y')}y`
}
